import { env } from '@rsmus/react-env-image'
import { Get, timeout } from '../services/http'

import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { apiRequestAsync } from '../redux/Actions/actions'
import { HttpRequestState, Organization } from '../models/core'
import { useHttpErrors } from './useHttpError'
// let controller = new AbortController()

export const useOrganization = () => {
  const dispatch = useDispatch()
  // const { signal } = controller
  const baseUrl = env('REACT_APP_ODATA_BASE_URL')

  const [requestStatus, setRequestStatus] = useState<HttpRequestState>('Idle')
  const [organization, setOrganization] = useState<Organization>()
  const { handleNotOkResponse, handleRequestError } = useHttpErrors()
  const getOrganization = useCallback(
    async (organizationId: string) => {
      if (!baseUrl) {
        return
      }

      try {
        setRequestStatus('InProgress')
        dispatch(apiRequestAsync.request)
        const response = await timeout(
          30000,
          Get(`${baseUrl}/api/organizations/${organizationId}`)
        )
        if (response.ok) {
          const data = await response.json()
          setOrganization(data)
          setRequestStatus('Success')
          dispatch(apiRequestAsync.success)
        } else {
          setRequestStatus('Failed')
          await handleNotOkResponse(response)
        }
      } catch (error) {
        setRequestStatus('Failed')
        handleRequestError(error)
      }
    },
    // eslint-disable-next-line
    [baseUrl, dispatch]
  )

  return { getOrganization, requestStatus, organization }
}
